import {
  QBox,
  QFormControl,
  QSelect,
  QSelectItem,
  QSelectPlaceholder,
  QText,
} from '@qualio/ui-components';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { getStatusValueLabelMap } from '../constants';

export const StatusFilter = () => {
  const { t } = useTranslation();
  const statusOptions: readonly QSelectItem[] = Object.entries(
    getStatusValueLabelMap(),
  ).map(([value, label]) => ({ value, label }));

  return (
    <QFormControl label={t('labels.status')}>
      <Controller
        name="status"
        render={({ field: { onChange, value, ...field } }) => {
          return (
            <QBox data-cy="workspace-status-filter">
              <QSelect
                {...field}
                options={statusOptions}
                value={value ?? null}
                onChange={(item) => {
                  onChange(item?.value ?? null);
                }}
                isClearable={true}
                clearInputOnSelect={value == null}
              >
                <QSelectPlaceholder>
                  <QText>{t('forms.filterByStatus')}</QText>
                </QSelectPlaceholder>
              </QSelect>
            </QBox>
          );
        }}
      />
    </QFormControl>
  );
};
